function Footer({onClickImpressum, onClickDatenschutz, onClickWelcome}) {
    return (
        <div className="container">
            <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
                <div className="col-md-4 d-flex justify-content-start">
                    <span className="mb-0 text-body-secondary">© 2026 Prof. Dr. Jan-Peer Rudolph</span>
                </div>
                <a href="/#"
                   className="col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none"
                   aria-label="quiz and pass" onClick={onClickWelcome}>
                    <img height={"60"} width={"auto"} aria-hidden="true" src="/quizandpass_logo_vertical.png"
                         alt="quiz and pass"/>
                </a>
                <ul className="nav col-md-4 justify-content-end">
                    <li key="nav-item-impressum" className="nav-item">
                        <a href="/#" className="nav-link px-2 text-body-secondary" onClick={onClickImpressum}>
                            Impressum
                        </a>
                    </li>
                    <li key="nav-item-datenschutz" className="nav-item">
                        <a href="/#" className="nav-link px-2 text-body-secondary" onClick={onClickDatenschutz}>
                            Datenschutz
                        </a>
                    </li>
                </ul>
                <div className="justify-content-start">
                    <span className="mb-0 text-body-secondary">
                        <small>
                            Ein Projekt zur Unterstützung von Lehre und Weiterbildung.
                        </small>
                    </span>
                </div>
                <div className="justify-content-start">
                    <span className="mb-0 text-body-secondary">
                        <small>
                            Diese Seite nutzt ausschließlich technisch notwendige Cookies.
                        </small>
                    </span>
                </div>
            </footer>
        </div>
    );
}

export default Footer;